import { GetterTree } from 'vuex';
import { QuerySignalsState } from '../../models';
import { RootStoreState } from '../store.interfaces';
import { NextQueriesFiltersGetter } from './getters/next-queries-filters.getter';
import { NextQueriesWithResultsGetter } from './getters/next-queries-with-results.getter';
import { NextQueriesGetter } from './getters/next-queries.getter';
import { SelectedRelatedTagsGetter } from './getters/selected-related-tags.getter';

export const QUERY_SIGNALS_GETTERS: GetterTree<QuerySignalsState, RootStoreState> = {
  ...new NextQueriesGetter().getters,
  ...new NextQueriesWithResultsGetter().getters,
  ...new NextQueriesFiltersGetter().getters,
  ...new SelectedRelatedTagsGetter().getters
};
